var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconWindowsApp = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 96,
    height: 96,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M96 0H0v96h96V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M83.619 4H12.381A8.38 8.38 0 0 0 4 12.38v71.24A8.381 8.381 0 0 0 12.38 92h71.24A8.381 8.381 0 0 0 92 83.619V12.381A8.381 8.381 0 0 0 83.619 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillOpacity: 0.15,
    d: "M46.96 26.16h20.8v4.16h-20.8z",
    transform: "rotate(-180 46.96 26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillOpacity: 0.15,
    d: "M26.16 26.16h4.16v4.16h-4.16z",
    transform: "rotate(-180 26.16 26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillOpacity: 0.15,
    d: "M26.16 46.96h20.8v4.16h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillOpacity: 0.2,
    d: "M26.16 46.96h20.8v4.16h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillOpacity: 0.15,
    d: "M46.96 46.96h4.16v4.16h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillOpacity: 0.2,
    d: "M46.96 46.96h4.16v4.16h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillOpacity: 0.15,
    d: "M26.16 46.96h4.16v4.16h-4.16z",
    transform: "rotate(90 26.16 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    fillOpacity: 0.2,
    d: "M26.16 46.96h4.16v4.16h-4.16z",
    transform: "rotate(90 26.16 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    fillOpacity: 0.15,
    d: "M46.96 26.16h4.16v4.16h-4.16z",
    transform: "rotate(-90 46.96 26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    fillOpacity: 0.15,
    d: "M46.96 46.96h20.8v4.16h-20.8z",
    transform: "rotate(-90 46.96 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    fillOpacity: 0.2,
    d: "M46.96 46.96h20.8v4.16h-20.8z",
    transform: "rotate(-90 46.96 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    fillOpacity: 0.15,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 26.16 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    fillOpacity: 0.2,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 26.16 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    fillOpacity: 0.15,
    d: "M46.96 49.04h20.8v4.16h-20.8z",
    transform: "rotate(-180 46.96 49.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    fillOpacity: 0.15,
    d: "M26.16 49.04h4.16v4.16h-4.16z",
    transform: "rotate(-180 26.16 49.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    fillOpacity: 0.15,
    d: "M26.16 69.84h20.8V74h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    fillOpacity: 0.2,
    d: "M26.16 69.84h20.8V74h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    fillOpacity: 0.15,
    d: "M46.96 69.84h4.16V74h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    fillOpacity: 0.2,
    d: "M46.96 69.84h4.16V74h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    fillOpacity: 0.15,
    d: "M26.16 69.84h4.16V74h-4.16z",
    transform: "rotate(90 26.16 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    fillOpacity: 0.2,
    d: "M26.16 69.84h4.16V74h-4.16z",
    transform: "rotate(90 26.16 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    fillOpacity: 0.15,
    d: "M46.96 49.04h4.16v4.16h-4.16z",
    transform: "rotate(-90 46.96 49.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    fillOpacity: 0.15,
    d: "M46.96 69.84h20.8V74h-20.8z",
    transform: "rotate(-90 46.96 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    fillOpacity: 0.2,
    d: "M46.96 69.84h20.8V74h-20.8z",
    transform: "rotate(-90 46.96 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    fillOpacity: 0.15,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 26.16 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    fillOpacity: 0.2,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 26.16 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    fillOpacity: 0.15,
    d: "M69.84 26.16h20.8v4.16h-20.8z",
    transform: "rotate(-180 69.84 26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    fillOpacity: 0.15,
    d: "M49.04 26.16h4.16v4.16h-4.16z",
    transform: "rotate(-180 49.04 26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    fillOpacity: 0.15,
    d: "M49.04 46.96h20.8v4.16h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    fillOpacity: 0.2,
    d: "M49.04 46.96h20.8v4.16h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    fillOpacity: 0.15,
    d: "M69.84 46.96H74v4.16h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    fillOpacity: 0.2,
    d: "M69.84 46.96H74v4.16h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    fillOpacity: 0.15,
    d: "M49.04 46.96h4.16v4.16h-4.16z",
    transform: "rotate(90 49.04 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#K)",
    fillOpacity: 0.2,
    d: "M49.04 46.96h4.16v4.16h-4.16z",
    transform: "rotate(90 49.04 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#L)",
    fillOpacity: 0.15,
    d: "M69.84 26.16H74v4.16h-4.16z",
    transform: "rotate(-90 69.84 26.16)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#M)",
    fillOpacity: 0.15,
    d: "M69.84 46.96h20.8v4.16h-20.8z",
    transform: "rotate(-90 69.84 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#N)",
    fillOpacity: 0.2,
    d: "M69.84 46.96h20.8v4.16h-20.8z",
    transform: "rotate(-90 69.84 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#O)",
    fillOpacity: 0.15,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 49.04 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#P)",
    fillOpacity: 0.2,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 49.04 46.96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q)",
    fillOpacity: 0.15,
    d: "M69.84 49.04h20.8v4.16h-20.8z",
    transform: "rotate(-180 69.84 49.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#R)",
    fillOpacity: 0.15,
    d: "M49.04 49.04h4.16v4.16h-4.16z",
    transform: "rotate(-180 49.04 49.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#S)",
    fillOpacity: 0.15,
    d: "M49.04 69.84h20.8V74h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#T)",
    fillOpacity: 0.2,
    d: "M49.04 69.84h20.8V74h-20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#U)",
    fillOpacity: 0.15,
    d: "M69.84 69.84H74V74h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#V)",
    fillOpacity: 0.2,
    d: "M69.84 69.84H74V74h-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#W)",
    fillOpacity: 0.15,
    d: "M49.04 69.84h4.16V74h-4.16z",
    transform: "rotate(90 49.04 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#X)",
    fillOpacity: 0.2,
    d: "M49.04 69.84h4.16V74h-4.16z",
    transform: "rotate(90 49.04 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Y)",
    fillOpacity: 0.15,
    d: "M69.84 49.04H74v4.16h-4.16z",
    transform: "rotate(-90 69.84 49.04)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Z)",
    fillOpacity: 0.15,
    d: "M69.84 69.84h20.8V74h-20.8z",
    transform: "rotate(-90 69.84 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#aa)",
    fillOpacity: 0.2,
    d: "M69.84 69.84h20.8V74h-20.8z",
    transform: "rotate(-90 69.84 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ab)",
    fillOpacity: 0.15,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 49.04 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ac)",
    fillOpacity: 0.2,
    d: "M0 0h20.8v4.16H0z",
    transform: "matrix(0 -1 -1 0 49.04 69.84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M26 26h21v21H26V26Zm0 23v21h21V49H26Zm23 0v21h21V49H49Zm21-2V26H49v21h21Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -18.498 44.658) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -33.206 80.166) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -33.206 80.166) scale(2.94156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -43.606 55.058) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -43.606 55.058) scale(2.94156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -8.098 69.766) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 46.96 46.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -46.116 56.098) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -60.824 91.606) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -60.824 91.606) scale(2.94156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -71.224 66.498) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -71.224 66.498) scale(2.94156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -35.717 81.206) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 46.96 69.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -7.058 72.277) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -21.766 107.784) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -21.83 107.742) scale(2.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -32.166 82.677) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -32.166 82.677) scale(2.94156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 3.342 97.384) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 69.84 46.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "P",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "R",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -34.677 83.717) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "U",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -49.384 119.224) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -49.448 119.16) scale(2.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "W",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -59.784 94.116) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -59.784 94.116) scale(2.94156)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -24.277 108.824) scale(4.05039)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 69.84 69.84)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(10.39994 2.07998 -.8 4 0 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -2.286,
    x2: 80.442,
    y1: -2.286,
    y2: 97.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#3DD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#0091EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#5D5DE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7339D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 57.36,
    x2: 57.36,
    y1: 26.16,
    y2: 30.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 36.56,
    x2: 36.56,
    y1: 46.96,
    y2: 51.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 36.56,
    x2: 36.56,
    y1: 46.96,
    y2: 49.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 57.36,
    x2: 57.36,
    y1: 46.96,
    y2: 51.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 10.4,
    x2: 10.4,
    y1: 0,
    y2: 4.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 57.36,
    x2: 57.36,
    y1: 49.04,
    y2: 53.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 36.56,
    x2: 36.56,
    y1: 69.84,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 36.56,
    x2: 36.56,
    y1: 69.84,
    y2: 71.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 57.36,
    x2: 57.36,
    y1: 69.84,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 10.4,
    x2: 10.4,
    y1: 0,
    y2: 4.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 80.24,
    x2: 80.24,
    y1: 26.16,
    y2: 30.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 59.44,
    x2: 59.44,
    y1: 46.96,
    y2: 51.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 59.44,
    x2: 59.44,
    y1: 46.96,
    y2: 49.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "M",
    x1: 80.24,
    x2: 80.24,
    y1: 46.96,
    y2: 51.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "O",
    x1: 10.4,
    x2: 10.4,
    y1: 0,
    y2: 4.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q",
    x1: 80.24,
    x2: 80.24,
    y1: 49.04,
    y2: 53.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "S",
    x1: 59.44,
    x2: 59.44,
    y1: 69.84,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "T",
    x1: 59.44,
    x2: 59.44,
    y1: 69.84,
    y2: 71.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Z",
    x1: 80.24,
    x2: 80.24,
    y1: 69.84,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 10.4,
    x2: 10.4,
    y1: 0,
    y2: 4.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconWindowsApp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon_WindowsApp.ea24cde25e3084e72ce51ff30a1bd810.svg";